import React, { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

function FrontLayout() {
  const navigate = useNavigate();
  useEffect(() => {
    let deviceId = localStorage.getItem("deviceId");
    let token = localStorage.getItem("token");
    if (deviceId && token) {
      navigate('/admin/dashboard');
    }
  }, []);
  return (
    <>
      <div class="container-scroller">
        <div class="container-fluid page-body-wrapper full-page-wrapper">
          <div class="content-wrapper d-flex align-items-stretch auth auth-img-bg">
            <div class="row flex-grow">
              <Outlet />
              <div class="col-lg-6 login-half-bg d-flex flex-row">
                <p class="text-white font-weight-medium text-center flex-grow align-self-end">Copyright &copy; 2026  All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default FrontLayout;
